import { Helper } from '../Helper';
export class GetGlobalPropertyHelper extends Helper {
    constructor(options) {
        super();
        this.property = options.property;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.scope.getGlobal(sb, node, options);
        sb.emitPushInt(node, this.property);
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=GetGlobalPropertyHelper.js.map
